import type { ShareAuthCheckData, AuthPageParams } from '../types';

export interface AuthService {
    /**
     * 应用启动时全局初始化：仅解析并写入真实 isLogin，无任何拦截器副作用。
     * isShare 保持默认 false，进入具体分享资源时由 shareAccessCheck 刷新。
     */
    initAuthState(): Promise<void>;
    shareAccessCheck(data?: ShareAuthCheckData): Promise<boolean>;
    setPageParams(params: AuthPageParams): void;
    get pageParams(): AuthPageParams;
}

export const AuthService = Symbol('AuthService');
